<template>
<div class="relative">
	<v-form v-model="valid" ref="form">
		<v-dialog v-model="addDialog" persistent transition="dialog-top-transition" content-class="white rounded-xl" width="550" height="60vh">
			<v-stepper v-model="steps" class="rounded-lg">
				<v-stepper-header>
					<v-stepper-step
					  :complete="steps > 1"
					  step="1"
					  :editable="!loading"
					>
					{{ $t('WarehousesPage.warehouse-data') }}
					</v-stepper-step>
			  
					<v-divider></v-divider>
			  
					<v-stepper-step
						:complete="steps > 2"
						step="2"
						:editable="valid && !loading"
					>
					{{ $t('WarehousesPage.import-materials-from-warehouse') }}
					</v-stepper-step>
			  
					<v-divider></v-divider>
			  
					<v-stepper-step step="3" :editable="valid">
						{{ formTitle }}
					</v-stepper-step>
				  </v-stepper-header>
				  <v-stepper-items>
					<v-stepper-content class="py-1 px-0" step="1">
						<v-card>
							<v-card-text class="pb-0">
								<v-row justify="center">
									<v-col cols="6" class="pb-0">
										<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.name" :label="$t('WarehousesPage.warehouse-name')" :rules="[rules.required]"></bee-text-field>
									</v-col>
									<v-col cols="6" class="pb-0">
										<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.notes" :label="$t('WarehousesPage.notes')"></bee-text-field>
									</v-col>
			
								</v-row>
							</v-card-text>
			
							<v-card-actions class="px-5">
								<v-btn
									text 
									disabled
									@click="steps ='1'"
								>
								{{ $t('buttons.back') }}
								</v-btn>
								<v-btn color="greenDarken1" text @click="steps = '2'" :disabled="!valid">
									{{$t('buttons.next')}}
								</v-btn>
								<v-btn color="redDarken1" text @click="reset()">
									{{$t('WarehousesPage.cancel')}}
								</v-btn>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
					<v-stepper-content class="py-1 px-0 " step="2">
						<v-card-text class="pb-0" id="test">
							<v-row>
								<v-col cols="6">
									<v-autocomplete
										v-model="warehouseId"
										:items="warehouses"
										item-text="name"
										item-value="id"
										label="المستودع"
										hide-details
										outlined
										dense
										:loading="loading"
										@change="materialsTree= [];getMaterialsTree(warehouseId);"
									></v-autocomplete>
								</v-col>
								<v-col cols="12" class="py-0">
									<v-row>
										<v-col cols="8">
											<v-autocomplete
											v-if="materialsTree.length"
											v-model="materialId"
											:items="flatMaterials.filter(v => v.type === type.sub)"
											outlined
											dense
											:label="$t('WarehousesPage.search-and-select-material')"
											hide-details
											item-text="name"
											item-value=id
											
											@change="MaterialsTreeFilterActivate(materialId)"
										></v-autocomplete>
										</v-col>
										<v-col cols="4" class="pt-1 px-0">
											<div v-if="materialsTree.length" class="d-flex align-center">

												<v-checkbox 
													v-model="linkMaterials"
													class="my-0"
													dense
													:label="$t('WarehousesPage.link-materials')"
													hide-details 
												/>
												<v-menu offset-y max-width="250" open-on-hover>
													<template v-slot:activator="{ on, attrs }">
														<i
															v-bind="attrs"
															v-on="on"
															class="fas fa-info-circle mt-2 mx-2 primary--text"
														/>
													</template>
													<div class="pa-2 text-body-2" :style="'background: rgba(255,255,255,0.7)'">
														<span>{{$t('WarehousesPage.link-materials-alert')}}</span>
													</div>
												</v-menu>

											</div>
											<v-checkbox
												v-if="materialsTree.length"
												class="ma-0 pt-0"
												dense
												hide-details 
												:label="$t('select-all')"
												:value="
													selectedChildrenMaterials.length === (flatMaterialsId.length - this.parentMaterialsCount)
														? true
														: false 
												"
												:indeterminate="Boolean(selectedChildrenMaterials.length && selectedChildrenMaterials.length !== flatMaterialsId.length - this.parentMaterialsCount)"
												@click="selectAllMaterials()"
											></v-checkbox>
										</v-col>
									</v-row>
									<v-treeview
										v-model="selectedChildrenMaterials"
										:open.sync="openedNodes"
										:active.sync="activeMaterials"
										:style="materialsTree.length?'height:40vh;overflowY:auto':'overflowY:auto'"
										:items="materialsTree"
										:selectable="true"
										activatable
										selection-type="leaf"
										item-text=""
										transition
										dense
										selected-color="primary"
										open-on-click
									>
										<template v-slot:prepend="{item}">
											<p :id="'material-'+ item.id" class="ma-0">{{item.name}}</p>
										</template>
									</v-treeview>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions >
							<v-btn
								text 

								@click="steps ='1'"
							>
							{{ $t('buttons.back') }}
							</v-btn>
							<v-btn
								text 
								color="success"
								:loading="loading"
								@click="
								steps = '3';
								/*add the parent materials because the tree view select only child materials (leaf)*/
									allSelectedMaterials = [...selectedChildrenMaterials];
									allSelectedMaterials.forEach(v => {
										addParentMaterials(v);
									})
								"
							>
								<span v-if="selectedChildrenMaterials.length">
									{{ $t('buttons.next') }}
								</span>
								<span  v-else>
									{{ $t('buttons.skip') }}
								</span>
							</v-btn>
							<v-btn color="redDarken1" text @click="reset()">
								{{$t('WarehousesPage.cancel')}}
							</v-btn>
						</v-card-actions>
					</v-stepper-content>
					<v-stepper-content class="py-1 px-0" step="3">
						<v-card>
							<v-card-text>
								<div v-if="loading && this.selectedChildrenMaterials.length"> 
									<v-progress-linear
										class="my-2"
										:value="createProgress"
									/>
									<p class="ma-0">
										<span v-if="createProgress === 0">
											{{ $t('WarehousesPage.creating-warehouse') }}
										</span>
										<span
											v-if="createProgress === 50"
											v-html="$t('WarehousesPage.warehouse-created-successfully')"
											class="d-flex align-center"
										>
										</span>
									</p>
								</div>
								<div v-else>
									<p class="ma-0">
										{{ $t('WarehousesPage.create') }}
										<span>
											"{{ row.name}}"
										</span>
										<span v-if="allSelectedMaterials.length">
											{{ $t('WarehousesPage.contain') }}
											"{{allSelectedMaterials.length}}"
											{{ $t('WarehousesPage.imported-materials') }}
											{{warehouses.find(v => v.id === warehouseId)?.name}}		
										</span>
										<span v-else>
											{{ $t('WarehousesPage.no-imported-materials') }}
										</span>
										<span>
											{{ $t('WarehousesPage.are-you-sure') }}
										</span>
									</p>
								</div>
							</v-card-text>
							<v-card-actions >
								<v-btn
									text 
									:disabled="loading"
									@click="steps ='2'"
								>
								{{ $t('buttons.back') }}
								</v-btn>
								<v-btn
									text 
									color="success"
									:loading="loading"
									@click="save()"
								>
									{{ $t('buttons.ok') }}
								</v-btn>
								<v-btn color="redDarken1" text @click="reset()">
									{{$t('WarehousesPage.cancel')}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
				  </v-stepper-items>
			</v-stepper>
		</v-dialog>
		<v-dialog v-model="miniAddDialog" persistent max-width="400px" transition="dialog-top-transition">
			<v-card>
				<v-card-title>
					{{ formTitle }}
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row justify="center">
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.name" :label="$t('WarehousesPage.warehouse-name')" :rules="[rules.required]"></bee-text-field>
						</v-col>
						<v-col cols="12" class="pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.notes" :label="$t('WarehousesPage.notes')"></bee-text-field>
						</v-col>

					</v-row>
				</v-card-text>

				<v-card-actions class="px-5">
					<v-btn color="greenDarken1" text @click="save()" :disabled="!valid">
						{{$t('buttons.create')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="reset()">
						{{$t('WarehousesPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="editDialog" persistent max-width="400px" transition="dialog-top-transition">
			<v-card>
				<v-card-title>
					{{ formTitle }}
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row justify="center">
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.name" :label="$t('WarehousesPage.warehouse-name')" :rules="[rules.required]"></bee-text-field>
						</v-col>
						<v-col cols="12" class="pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.notes" :label="$t('WarehousesPage.notes')"></bee-text-field>
						</v-col>

					</v-row>
				</v-card-text>

				<v-card-actions class="px-5">
					<v-btn color="greenDarken1" text @click="save()" :disabled="!valid">
						{{$t('buttons.save')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="reset()">
						{{$t('WarehousesPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div class="fixed white" style="width: 100%;" id="tool-bar">
		<v-row class="ma-0" style="width: 100%;" align="center" justify="start">
			<v-col cols="12" sm="6" xs="6" md="6" lg="3" class="d-flex justify-start">
				<slot name="breadcrumbs"></slot>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" sm="6" xs="6" md="6" lg="2" class="d-flex justify-end">
				<bee-btn context="warehouse" :action-name="actions.CREATE" :disabled="file_is_locked" color="addingColor" :content="$t('WarehousesPage.create-warehouse')" @click="useWarehouseMaterialsCopy? addDialog = true : miniAddDialog = true"></bee-btn>
			</v-col>

		</v-row>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
		<v-card flat>
			<v-card-text class="pt-0 px-3">
				<bee-simple-table empty-state="dashes"
					:fixed-header="true"
					context="warehouse" :action-name="actions.CREATE"
					@delete="selectedId = $event.id; deleteDialog = true" 
					@edit=" row ={...$event}; editDialog=true"
					@inventory="goWarehouseInventory($event)"
					:configs="configs" 
					:with-color="true" :zebra="false"  
					:hide-footer="true" :headers="file_is_locked ? headers_when_file_is_locked : headers" :items="warehouses">
				</bee-simple-table>
			</v-card-text>
		</v-card>
		<bee-dialog
		    :persistent="true"
		    @handler="confirmDelete()"
		    @close="reset()"
		    v-model="deleteDialog"
		    :title="$t('WarehousesPage.delete-the-warehouse')"
		    :message="$t('WarehousesPage.are-you-sure-you-want-to-delete-the-warehouse')"
		></bee-dialog>
		</div>
	</v-form>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import actions from "../../../permissions/actions-names.js"
import { type } from "@/helpers/enums";
import { useWarehouseMaterialsCopy } from '@/configs/global.js'
export default {
data: () => ({
	actions,
	deleteDialog: false,
	addDialog: false,
	valid: false,
	selectedId: null,
	...rules,
	type,
	row: {id: null, name: null, notes: null},
	materialsTreeDialog: false,
	warehouseId: null,
	materialsTree: [],
	flatMaterials: [],
	selectedChildrenMaterials: [],
	steps: '1',
	childrenMaterialsId: [],
	parentMaterialsCount: 0,
	allSelectedMaterials: [],
	loading: false,
	createProgress: 0,
	activeMaterials: [],
	openedNodes: [],
	materialId: null,
	editDialog: false,
	useWarehouseMaterialsCopy,
	linkMaterials: false,
	miniAddDialog: false
}),
mounted(){
	window.observer.observe(document.querySelector("#tool-bar"))
},
// watch: {
// 	'selected': {
// 		handler(newVal,oldVal) {
// 			console.log('newVal' + newVal);
// 			console.log('oldVal'+ oldVal);
// 		if(oldVal.length < newVal.length) {
// 			const material = this.flatMaterials.find(v => v.id === newVal[newVal.length - 1])

// 			if(material.parent_id) {
// 				const parent_material = this.flatMaterials.find(v => v.id === material.parent_id)
// 				if(newVal.findIndex(v => v.id === parent_material.id) === -1) {
// 					this.selected.push(parent_material.id);
// 				}
// 			}
// 		} else {
// 			const material = this.flatMaterials.find(oldVal.find(v => !newVal.includes(v)));
// 			if(material.parent_id) {
// 				if(this.flatMaterials.findIndex(v => material.parent_id === v.parent_id && newVal.includes(v.id)) === -1) {
// 					this.selected.splice(this.newVal.findIndex(v => v === material.parent_id), 1)
// 				}
// 			}
// 		}
// 		},
// 		deep:true
// 	}
// },
methods:{
	reset(){
		Object.keys(this.row).forEach(key => this.row[key] = null)
		this.addDialog = false
		this.miniAddDialog = false;
		this.deleteDialog = false;
		this.editDialog = false;
		this.$refs.form.resetValidation()
		this.selectedChildrenMaterials = [];
		this.allSelectedMaterials = [];
		this.loading = false;
		this.warehouseId = null;
		this.materialsTree = [];
		this.steps = 1;
	},
	save(){
		if(!this.row.id){
			this.loading = true;
			this.$store.dispatch("warehouses/create", { warehouse: this.row }).then((data)=>{ 
				if(this.selectedChildrenMaterials.length) {
					this.createProgress = 50;
					this.$store.dispatch('materials/copyWarehouseMaterials', 
						{id: data, materials: this.allSelectedMaterials, linked_with_another: this.linkMaterials}).then(() => {
							this.reset();
							this.progress = 100;
						}
					)
				} else {
					this.progress = 100;
					this.reset();
				}
				store.dispatch("warehouses/fetchAll") 
			}).finally(() =>  {})

			}
		else
			this.$store.dispatch("warehouses/update", { warehouse: this.row }).then(()=>{ store.dispatch("warehouses/fetchAll") }).finally(() =>  this.reset())
	},
	confirmDelete(){
		this.$store.dispatch("warehouses/delete",{ id: this.selectedId }).then(()=>{ store.dispatch("warehouses/fetchAll") }).finally(() =>  this.selectedId = null)
	},
	goWarehouseInventory(item){
		this.$router.push({ name: 'warehouses-inventory', query: { warehouseId: item.id } })
	},
	getMaterialsTree(id) {
		if(id) {
			this.loading = true;
			this.$store.dispatch("materials/getWarehouseMaterialsTree", id).then((data) => {
				this.materialsTree = data;
				this.flatMaterialsId = [];
				this.flatMaterials = [];
				this.parentMaterialsCount = 0;
				data.forEach(v => {
					this.childsCount(v)
				})
				this.loading = false;
			});
		}
	},
	selectAllMaterials() {
		if(this.selectedChildrenMaterials.length !== this.flatMaterialsId.length - this.parentMaterialsCount)
		{
			this.selectedChildrenMaterials = this.flatMaterialsId;
		}
		else {
			this.selectedChildrenMaterials = []
		}
		// console.log(this.active)
	},
	childsCount(item) {
		this.flatMaterialsId.push(item.id);
		this.flatMaterials.push(item);
		if(item.children)
		{
			++this.parentMaterialsCount;
			item.children.forEach(v => {
				this.childsCount(v)
			})
		}

	},
	addParentMaterials(materialId) {
		const parentMaterial = this.flatMaterials.find(v => v.id === materialId).parent_id
		if(parentMaterial && !this.allSelectedMaterials.includes(parentMaterial)) {
			this.allSelectedMaterials.push(parentMaterial)
			this.addParentMaterials(parentMaterial);
		}
	},
	MaterialsTreeFilterActivate(materialId) {
		if(materialId) {
			this.activeMaterials = [];
			this.openedNodes = [];
			this.activeMaterials.push(materialId);
			this.selectedChildrenMaterials.push( materialId);
			const material = this.flatMaterials.find(v => v.id === materialId);
			if(material.parent_id) {
				this.MaterialTreeFilterNodesOpen(material.parent_id);
			}
			this.$nextTick(() => {
				setTimeout(() =>{
					const el = document.getElementById('material-' + materialId);
					if (el) {
						el.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}, 300)
			})

			
		}
	},
	MaterialTreeFilterNodesOpen(materialId) {
		this.openedNodes.push(materialId);
		const material = this.flatMaterials.find(v => v.id === materialId);
		if(material.parent_id) {
			this.MaterialTreeFilterNodesOpen(material.parent_id);
		}
	}
},
computed: {
	...mapState("warehouses" , ["warehouses"]),
	...mapState("configs" , ["configs"]),
	formTitle() {
		return !this.row.id
		? this.$t('WarehousesPage.create-warehouse')
		: this.$t('WarehousesPage.edit-warehouse')
	},
	headers() {
		return [
			{
				text: this.$t('WarehousesPage.headers.no'),
				value: 'warehouse_no',
				type: 'string',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.warehouse-name'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '40%', settings: { itemText: 'name' }
			},
			{
				text: this.$t('WarehousesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%', actions: [
					{ name: 'edit', action_name: actions.EDIT }, 
					{ name: 'inventory', action_name: actions.GET },  
					{ name: 'delete', action_name: actions.DELETE },  
				]
			}
		]
	},
	headers_when_file_is_locked() {
		return [
			{
				text: this.$t('WarehousesPage.headers.no'),
				value: 'warehouse_no',
				type: 'string',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.warehouse-name'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '40%', settings: { itemText: 'name' }
			},
			{
				text: this.$t('WarehousesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%',
				actions: [{ name: 'inventory', action_name: actions.GET },]
			}
		]
	},
	file_is_locked(){ 
        return this.configs?.financial_file?.is_locked }
},
async beforeRouteEnter(to, from, next) {
	let promises = [store.dispatch('warehouses/fetchAll')]

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	if(promises.length)
		await Promise.all(promises)
	next();
}
};
</script>
<style scoped>

</style>